import type { IFlagProps } from "./types";

export function Flag(props: IFlagProps) {
  const { country } = props;

  return <span style={{ flex: "0 0 auto" }} className={`fi fi-${country}`} />;
}
